export function parseCompanyNumber(organizationName: string) {
  const words = organizationName.split(' ');
  const companyNumber = words.find((word) => !Number.isNaN(Number(word)));

  return companyNumber ? Number(companyNumber) : null;
}
